import { api } from '@api'

const getBillingBatch = async () => {
  try {
    const response = await api.get('/billing-batch')
    return response.data
  } catch (error) {
    console.error('Error al obtener los lotes:', error)
    throw error
  }
}

export { getBillingBatch }
